import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth/auth.service';
import { ToastService } from 'src/app/services/toast/toast.service';
import { StorageService } from 'src/app/services/storage/storage.service';
import {
  BreadcrumbService,
  BreadcrumbItem,
} from 'src/app/services/breadcrumb/breadcrumb.service';

type SettingsPermissions = {
  groups: boolean;
  companies: boolean;
  permissions: boolean;
  permissions_settings: boolean;
  witnesses: boolean;
};

@Component({
  selector: 'app-dashboard-permissions',
  templateUrl: './dashboard-permissions.component.html',
  styleUrls: ['./dashboard-permissions.component.scss'],
})
export class DashboardPermissionsComponent implements OnInit {
  canView: SettingsPermissions = {
    groups: false,
    companies: false,
    permissions: false,
    permissions_settings: false,
    witnesses: false,
  };

  showOnboarding = false; // Comentado: não mostra mais a explicação passo a passo

  constructor(
    private authService: AuthService,
    private toast: ToastService,
    private router: Router,
    private storageService: StorageService,
    private breadcrumbService: BreadcrumbService
  ) {}

  ngOnInit(): void {
    this.setPermissions();
    this.setBreadcrumb();

    // Comentado: verificação de onboarding removida - sempre vai direto para a página principal
    // const onboardingViewed = this.storageService.get(
    //   '@app:dashboard_permissions_onboarding_viewed'
    // );
    // if (onboardingViewed === 'true') {
    //   this.showOnboarding = false;
    // }

    // Se for master, sempre permite acesso (não bloqueia)
    if (this.authService.isMasterUser()) {
      return;
    }

    if (
      !this.canView.groups &&
      !this.canView.companies &&
      !this.canView.permissions &&
      !this.canView.permissions_settings
    ) {
      this.toast.show(
        'error',
        'Aviso',
        'Você não tem permissão para acessar essa página.'
      );
      this.router.navigateByUrl('/app/dashboard');
    }
  }

  setPermissions() {
    const permissionArr = [
      'de_can_view_groups',
      'de_can_view_companies',
      'de_can_view_permissions',
      'de_can_view_permissions_settings',
      'de_can_view_witnesses',
    ];

    // Se for master, todas as permissões são true
    if (this.authService.isMasterUser()) {
      permissionArr.forEach((permission) => {
        const label = permission.split('_').slice(3).join('_');
        this.canView[`${label}`] = true;
      });
      return;
    }

    permissionArr.forEach((permission) => {
      const label = permission.split('_').slice(3).join('_');

      this.canView[`${label}`] = this.authService.verifyPermission([
        permission,
      ]);
    });
  }

  closeOnboarding() {
    this.showOnboarding = false;
    // Salva no localStorage que o onboarding foi visto
    this.storageService.set(
      '@app:dashboard_permissions_onboarding_viewed',
      'true'
    );
  }

  showOnboardingHelp() {
    this.showOnboarding = true;
  }

  setBreadcrumb(): void {
    const breadcrumbs: BreadcrumbItem[] = [
      {
        label: 'Permissões',
        url: '/app/permissions',
        clickable: false, // Página atual, não precisa ser clicável
      },
    ];
    this.breadcrumbService.setBreadcrumbs(breadcrumbs);
  }
}
